<template>
  <div>
    <div class="control">
      <div v-if="isArray && !isSlider" v-for="(m, i) in privateModel" :key="i">
        <label class="label" v-if="label">{{label[i]}}</label>
        <div class="select is-margin-bottom-small">
          <select @change="change" v-model="privateModel[i]">
            <option :value="undefined">Aucun</option>
            <option :value="s" v-for="s in steps" :key="s">{{ formatedValue(s) }}</option>
          </select>
        </div>
      </div>
      <div v-if="isArray && isSlider">
        <label class="label" v-if="label">{{label}}</label>
        <vue-slider ref="slider"
                    class="vue-slider-component--crmimmo"
                    :class="[{'is-label-h-top':isLabelHTop}]"
                    :show="displaySlider"
                    v-bind="params"
                    v-if="params && displaySlider"
                    v-model="params.value"
                    @callback="rangeChange">
          
          <div slot="label" slot-scope="props" v-if="stepsLabel">
            <span class="vue-slider-piecewise-label" v-if="!maxStepsDisplay && props.first">{{ props.label }}</span>
            <span class="vue-slider-piecewise-label" :class="{'is-light':customIgnoreLabelCb(props.label)}"
                  v-if="displayLabel(props.label, props.index % maxSteps)">
              <span v-if="props.last">+ </span><span v-if="!customIgnoreLabelCb(props.label)">{{ props.label }}</span>
            </span>
          </div>
          <div slot="tooltip" class="vue-slider-tooltip is-size-6" slot-scope="{ value }">
            <span><span v-if="last(value)">+ </span>{{ customTooltip(value) }}</span>
          </div>

        </vue-slider>
      </div>
      <div v-if="!isArray">
        <label class="label" v-if="label">{{label}}</label>
        <div class="select">
          <select @change="change" v-model="privateModel">
            <option :value="undefined">Aucun</option>
            <option :value="s" v-for="s in steps" :key="s">{{ formatedValue(s) }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { range } from 'lodash'

  export default {
    name: 'RangeChooser',
    data () {
      return {
        privateModel: null,
        displaySlider: false
      }
    },
    props: {
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 100
      },
      step: {
        type: Number,
        default: 1
      },
      model: {
        required: true
      },
      formatter: {
        type: [String, Function],
        default: '{value}'
      },
      label: [String, Array],
      isSlider: {
        type: Boolean,
        default: false
      },
      // display dots
      dots: {
        type: Boolean,
        default: false
      },
      // add steps to slider
      stepsLabel: {
        type: Boolean,
        default: true
      },
      // pass suffix to manipulate labels in displayLabel and add custom labels
      suffix: {
        type: String,
        default: ' '
      },
      // pass number to manipulate label (ex: 100000 become 100)
      labelLimit: {
        type: Number,
        default: 1
      },
      // pass boolean or string to Rerender slider every time prop change (in watcher)
      reRender: {
        type: [Boolean, String],
        default: null
      },
      loading: {
        type: Boolean,
        default: false
      },
      // pass null for all steps (not recommended for huge range)
      maxSteps: {
        type: Number,
        default: 4
      },
      customLabels: {
        type: Array,
        default: () => []
      },
      customIgnoreLabels: {
        type: Array,
        default: () => []
      }
    },
    watch: {
      model (to) {
        this.updatePrivateModel(to)
      },
      reRender () {
        return this.render()
      }
    },
    computed: {
      slider () {
        if (!this.displaySlider) return
        if (!this.isSlider) return
        if (!this.$refs.slider) return
        return this.$refs.slider
      },
      isArray () {
        return Array.isArray(this.model)
      },
      steps () {
        return range(this.min, this.max + 1, this.step)
      },
      params () {
        if (!this.isSlider) return
        let model = 0
        if (this.isArray) model = [this.model[0] || this.min, this.model[1] || this.max]

        let params = {
          value: model,
          width: '100%',
          height: 12,
          dotSize: 16,
          min: this.min,
          max: this.max,
          interval: this.step,
          disabled: false,
          show: true,
          tooltip: 'hover',
          piecewise: false,
          tooltipMerge: false,
          piecewiseLabel: this.stepsLabel,
          formatter: this.formatter
        }
        if (this.dots) params.piecewise = true
        return params
      },
      isLabelHTop () {
        if (!this.stepsLabel) return false
        else return true
      },
      maxStepsArr () {
        if (Number.isInteger(this.maxSteps)) return this.maxSteps
        else return this.max
      },
      maxStepsDisplay () {
        return Number.isInteger(this.maxSteps)
      }
    },
    methods: {
      formatedValue (value) {
        return this.formatter.replace('{value}', Math.round(value * 100) / 100)
      },
      updatePrivateModel (model) {
        if (typeof model === 'object') this.privateModel = Object.assign(model)
        else this.privateModel = model
      },
      change () {
        this.$emit('change', this.privateModel)
      },
      rangeChange () {
        this.$emit('change', this.slider.getValue())
      },
      displayLabel (v, n) {
        if (this.maxStepsDisplay && !this.customLabels) {
          return Number(v.split(this.suffix)[0]) * this.labelLimit === ((this.max - this.min) / this.maxSteps) * n
        } else if (this.maxStepsDisplay && this.customLabels) {
          return this.customLabelCallback(v)
        } else return true
      },
      last (val) {
        return val === this.max
      },
      customLabelCallback (v) {
        return this.customLabels.includes(String(v.split(this.suffix)[0]))
      },
      customIgnoreLabelCb (v) {
        return this.customIgnoreLabels.includes(String(v.split(this.suffix)[0]))
      },
      customTooltip (v) {
        if (this.formatter && typeof this.formatter === 'function') {
          return this.formatter(v)
        } else return v
      },
      render () {
        setTimeout(() => this.$set(this, 'displaySlider', false), 100)
        setTimeout(() => this.$set(this, 'displaySlider', true), 250)
        if (this.$refs.slider) {
          setTimeout(() => this.$refs.slider.refresh(), 500)
        }
      }
    },
    created () {
      this.updatePrivateModel(this.model)
    },
    mounted () {
      this.render()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/RangeChooser.vue